import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RedirectService, StorageService, TranslateService } from '@services';
import { environment as env } from '@env/environment';
import { PlayerService } from 'src/app/services/player.service';

@Component({
    selector: 'msc-learn-detail-instance-summary',
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.scss'],
})

export class LearnDetailInstanceSummaryComponent {
    private _summary: any;
    @Input() instance: any;
    @Input() set summary(value: any) {
        this._summary = value;
        this.selectedSectionIndex = 0;
        if (value && Array.isArray(value)) {
            this.openSections = value.map(() => false);
        }
        }
        get summary(): any {
        return this._summary;
    }
    @Input() subscribed: boolean = false;
    @Input() processing: boolean = false;
    @Input() isLoaded: boolean = true;
    @Input() saved: boolean = false;
    @Output() onPlayContent = new EventEmitter<void>();
    @Output() onSubscribe = new EventEmitter<void>();
    @Output() onUnsubscribe = new EventEmitter<void>();
    @Output() onOpenConversation = new EventEmitter<void>();
    @Output() onSave = new EventEmitter<void>();
    @Output() onRate = new EventEmitter<void>();
    public openSections: boolean[] = [];
    public selectedSectionIndex: number = 0;
    public sidebarCollapsed: boolean = false;
    public company: any;
    public accordionOpen: { [key: string]: boolean } = {
        requirements: true,
        audience: false,
        purpose: false
    };

    public getTotalLessons(): number {
        return this.summary?.reduce((total: number, section: any) => total + (section.sectionContents?.length || 0), 0) || 0;
    }

    public getProviderLogoUrl(): string | null {
        const provider = this.instance?.provider;
        const rawLogo = this.company?.experience?.displayPicture || this.company?.picture;
        let url: string | null = null;

        if (provider?.media?.pictureUrl) {
            if (this.company?.id === provider.responsibleId && provider.responsibleType === 'company') {
                url = rawLogo ? `${rawLogo}?size=256` : null;
            } else {
                url = `${provider.media.pictureUrl}?size=256`;
            }
        } else if (rawLogo) {
            url = `${rawLogo}?size=256`;
        }

        if (url && !env.production && url.includes('api-upgraded.myskillcamp.com.deltabluecdn.com')) {
            url = url.replace('https://api-upgraded.myskillcamp.com.deltabluecdn.com', 'https://api.myskillcamp.com');
        }
        return url;
    }

    public convertSecondsToHoursMinutes(seconds: number): string {
        if (!seconds || seconds < 0 || isNaN(seconds)) return '0h0m';
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        return `${hours}h${minutes}m`;
    }

    constructor(private route: ActivatedRoute, private translateService: TranslateService, private redirectService: RedirectService, private playerService: PlayerService, private storageService: StorageService) { }

    ngOnInit(): void {
        this.company = this.storageService.get('company');
        this.route.parent.data.subscribe(data => {
            if (data.instance) {
                this.instance = data.instance;
                this.subscribed = !!data.instance.subscribed;
                this.saved = !!data.instance.saved;
            }
            if (data.summary) {
                this.summary = data.summary;
            }
        });
    }

 


    public descriptionExpanded = false;

    openDropdownSections(index: number): void {
        this.openSections[index] = !this.openSections[index];
    }

    toggleAccordionItem(item: string): void {
        this.accordionOpen[item] = !this.accordionOpen[item];
    }

    canProgressToSection(section: any): void {
        const sectionContents = section.sectionContents ? section.sectionContents.filter((content) => {
            if (!content.session || content.session.progress !== 100) {
                return content;
            }
        }) : [];

        this.redirectActivityToPlayer(section, sectionContents.length > 0 ? sectionContents[0] : null);
        
    }

    redirectActivityToPlayer(section: any, activity: any): void {
        if (activity) {
            if (activity.context === 'media') {
                //this.redirectService.navigate('player', ['course', this.summary.id, 'section', section.id, activity.context, activity.contextId, 'content', activity.id]);
                this.playerService.openIframe(`${env.envVar.PLAYER_URL}/course/${this.instance.id}/section/${section.id}/media/${activity.contextId}/content/${activity.id}`);
                console.log('Opening media activity in player:', `${env.envVar.PLAYER_URL}/course/${this.instance.id}/section/${section.id}/media/${activity.contextId}/content/${activity.id}`);
            } else if (activity.context === 'external_link') {
                //this.redirectService.navigate('player', ['course', this.summary.id, 'section', section.id, 'external-link', activity.contextId]);
                this.playerService.openIframe(`${env.envVar.PLAYER_URL}/course/${this.instance.id}/section/${section.id}/external-link/${activity.contextId}`);
                console.log('Opening external link activity in player:', `${env.envVar.PLAYER_URL}/course/${this.instance.id}/section/${section.id}/external-link/${activity.contextId}`);
            } else {
                //this.redirectService.navigate('player', ['course', this.summary.id, 'section', section.id, activity.context, activity.contextId]);
                this.playerService.openIframe(`${env.envVar.PLAYER_URL}/course/${this.instance.id}/section/${section.id}/${activity.context}/${activity.contextId}`);
                console.log('Opening activity in player:', `${env.envVar.PLAYER_URL}/course/${this.instance.id}/section/${section.id}/${activity.context}/${activity.contextId}`);
            }
        } else {
            //this.redirectService.navigate('player', ['course', this.summary.id, 'section', section.id]);
            this.playerService.openIframe(`${env.envVar.PLAYER_URL}/course/${this.instance.id}/section/${section.id}`);
            console.log('Opening section in player:', `${env.envVar.PLAYER_URL}/course/${this.instance.id}/section/${section.id}`);
        }
    }

    getTranslationButton(section: any): string {
        if (section.progress) {
            if (section.progress.finishedPercent > 0 && section.progress.finishedPercent < 100) {
                return this.translateService.instant('words.continue');
            } else if (section.progress.finishedPercent === 100) {
                return this.translateService.instant('words.resume');
            } else {
                return this.translateService.instant('words.start');
            }
        }
        return this.translateService.instant('words.start');
    }

    getTranslationButtonActivity(activity: any): string {
        if (activity.session) {
            if (activity.session.progress > 0 && activity.session.progress < 100) {
                return this.translateService.instant('words.continue');
            } else if (activity.session.progress === 100) {
                return this.translateService.instant('words.resume');
            } else {
                return this.translateService.instant('words.start');
            }
        }
        return this.translateService.instant('words.start');
    }

    getActivityIcon(context: string): string {
        switch (context) {
            case 'media':
                return 'icon-video';
            case 'cheatsheet':
                return 'icon-file-text';
            case 'exercise':
                return 'icon-checkmark-square';
            case 'event':
                return 'icon-calendar';
            case 'exchange':
                return 'icon-message-circle';
            case 'project':
                return 'icon-clipboard';
            default:
                return 'icon-checkmark-square';
        }
    }

    public openIframe(aditionalUrl?: string): void {
        const url = `${env.envVar.PLAYER_URL}/course/${aditionalUrl}`;
        this.playerService.openIframe(url);
    }
}
